
/*----------------------
    BLOCKS INFO
---------------------- */
BlocksInfo = {
    init: function () {
        $(".product__info__block__item__title").on("click", function () {
            var parent = $(this).closest(".product__info__block__item");
            $('.product__info__block__item').not(parent).removeClass('current');
            $(parent).toggleClass("current");
        });

        $("body").on("click", function (e) {
            if (!$(e.target).closest('.product__info__block__item, .product__info__block__item__text').length) {
                $('.product__info__block__item').removeClass('current');
            }
        })
    }
};


/*----------------------
 STICKY
 ----------------------*/
Sticky = {
    refresh: function () {
        var $productInfo = $(".product-info");
        if (!$productInfo.length) return;

        var headerHeight = $(".site-header__inner").outerHeight() || 0;
        var topOffset = headerHeight + 60;
        var bottomOffset = 60;
        var productInfoHeight = $productInfo.outerHeight();
        var windowHeight = $(window).height();

        if (productInfoHeight + topOffset > windowHeight) {
            $productInfo.css("top", windowHeight - productInfoHeight - bottomOffset);
        } else {
            $productInfo.css("top", topOffset);
        }
    },
    refreshLater: function () {
        var delays = [0, 60, 180, 360, 460];

        delays.forEach(function (delay) {
            setTimeout(function () {
                Sticky.refresh();
            }, delay);
        });
    },
    init: function () {
        Sticky.refresh();

        $(window).on("resize", function () {
            Sticky.refresh();
        });

        $("body").on("click", function (e) {
            Sticky.refreshLater();
        })
    }
};


/*----------------------
    OPEN VARIATIONS
---------------------- */
openVariations = {
    init: function () {
        $(".attributes__title").on("click", function () {
            $(this).closest(".attributes-values").toggleClass("open");
        });
        $("body").on("click", function (e) {
            if (!$(e.target).closest('.attributes__title, .attributes-values').length) {
                $(".attributes-values").removeClass("open");

            }
        })
    }
};

/*----------------------
    PRODUCT QUANTITY
---------------------- */
ProductQuantity = {
    init: function () {
        $(".quantity-input--wrapper .number-input").each(function () {
            var $quantity = $(this);

            if ($quantity.data("quantity-initialized")) return;

            $quantity.data("quantity-initialized", true);

            $quantity.find(".plus").on("click", function (event) {
                var input = $quantity.find('input[type="number"]')[0];
                if (!input) return;

                event.preventDefault();
                input.stepUp();
                input.dispatchEvent(new Event("change", { bubbles: true }));
            });

            $quantity.find(".minus").on("click", function (event) {
                var input = $quantity.find('input[type="number"]')[0];
                if (!input) return;

                event.preventDefault();
                input.stepDown();
                input.dispatchEvent(new Event("change", { bubbles: true }));
            });
        });
    }
};

/*----------------------
    PRODUCT DESCRIPTION
---------------------- */
ProductDescription = {
    init: function () {
        $(".product-description").each(function () {
            var $description = $(this);
            var $paragraphs = $description.children("p");

            if ($description.data("initialized") || $paragraphs.length <= 1) return;

            var readMoreText = $description.data("read-more");
            var readLessText = $description.data("read-less");
            var $button = $('<button type="button" class="product-description__toggle t25-14 inter-font" aria-expanded="false"></button>');

            $description.data("initialized", true);
            $description.addClass("product-description--collapsed");
            $button.text(readMoreText);
            $description.append($button);

            requestAnimationFrame(function () {
                $description.addClass("product-description--ready");
            });

            $button.on("click", function () {
                var isExpanded = $description.toggleClass("product-description--expanded").hasClass("product-description--expanded");

                $description.toggleClass("product-description--collapsed", !isExpanded);
                $button.attr("aria-expanded", isExpanded ? "true" : "false");
                $button.text(isExpanded ? readLessText : readMoreText);
                Sticky.refreshLater();
            });
        });
    }
};

/*----------------------
   SWIPER PRODUCT
---------------------- */
var productSwiper = null;
SwiperProduct = {
    init: function () {
        if ($(window).width() <= 640) {
            var swiper = new Swiper(".swiper-product-images", {
                navigation: {
                    nextEl: ".swiper-product-images-next",
                    prevEl: ".swiper-product-images-prev",
                },
                scrollbar: {
                    el: ".swiper-scrollbar",
                    hide: false,
                    draggable: true,
                },
            });

        }
    }
};

$(document).ready(function () {
    BlocksInfo.init();
    openVariations.init();
    ProductQuantity.init();
    ProductDescription.init();
    Sticky.init();
    SwiperProduct.init();
});
$(document).on('shopify:section:load', function (event) {
    BlocksInfo.init();
    openVariations.init();
    ProductQuantity.init();
    ProductDescription.init();
    //Sticky.init();
    SwiperProduct.init();
});
